<ui-catalog-search (searchParamsUpdate)="this.navigateToParams($event)" [searchParams]="searchParams()"></ui-catalog-search>
